(() => {
  if (customElements.get('lookbook-add-all')) return;

  class LookbookAddAll extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.button = this.querySelector('button');
      this.errorMessage = this.querySelector('.product-form__error-message');
      this.cartDrawer = document.querySelector('cart-drawer');

      if (this.button) {
        this.button.addEventListener('click', this.handleClick.bind(this));
      }
    }

    getVariantIds() {
      const slider = this.closest('lookbook-card-slider');
      if (!slider) return [];

      const ids = [...slider.querySelectorAll('[data-lookbook-variant-id]')]
        .map((input) => Number(input.value))
        .filter(Boolean);

      // Evitam dublurile introduse de carusel; la fiecare apasare adaugam
      // totusi o bucata din fiecare varianta distincta.
      return [...new Set(ids)];
    }

    getFetchConfig() {
      if (window.FoxTheme?.utils?.fetchConfig) {
        return window.FoxTheme.utils.fetchConfig('javascript');
      }

      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
      };
    }

    async handleClick(event) {
      event.preventDefault();
      if (this.isSubmitting) return;

      const variantIds = this.getVariantIds();
      if (!variantIds.length) {
        this.showError(this.dataset.gnNoneAvailable || 'There are no available products to add to your cart.');
        return;
      }

      const routes = window.FoxTheme?.routes || {};
      const cartAddUrl = routes.cart_add_url || '/cart/add.js';
      const cartPageUrl = routes.cart_url || '/cart';
      const cartJsonUrl = cartPageUrl.endsWith('.js')
        ? cartPageUrl
        : `${cartPageUrl.replace(/\/$/, '')}.js`;
      const hasDrawer = !document.body.classList.contains('cart-template')
        && window.FoxTheme?.settings?.cartType === 'drawer';

      this.isSubmitting = true;
      this.showError();
      this.toggleLoading(true);

      try {
        const sectionsToBundle = [];
        if (hasDrawer) {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            })
          );
        }

        // IMPORTANT: /cart/add.js mareste cantitatea daca varianta exista deja.
        // Nu folosim /cart/update.js, care in versiunea veche reseta la 1.
        const addBody = {
          items: variantIds.map((id) => ({ id, quantity: 1 })),
        };
        if (hasDrawer && sectionsToBundle.length) {
          addBody.sections = [...new Set(sectionsToBundle)];
          addBody.sections_url = window.location.pathname;
        }

        const addResponse = await fetch(cartAddUrl, {
          ...this.getFetchConfig(),
          body: JSON.stringify(addBody),
        });
        const addedState = await addResponse.json();
        if (!addResponse.ok || addedState.status) {
          throw new Error(
            addedState.description || addedState.message || this.dataset.gnAddError || 'The products could not be added to your cart.'
          );
        }

        if (!hasDrawer) {
          window.location.href = cartPageUrl;
          return;
        }

        // Luam cosul real dupa fiecare adaugare, inclusiv la apasari repetate.
        // Adresa /cart.js accepta GET si returneaza datele JSON actualizate.
        let cartState = null;
        try {
          const cartResponse = await fetch(cartJsonUrl, {
            method: 'GET',
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          });
          if (!cartResponse.ok) throw new Error(this.dataset.gnReadError || 'The cart could not be loaded.');
          cartState = await cartResponse.json();
        } catch (refreshError) {
          console.warn('Lookbook: reimprospatarea cosului se face prin tema.', refreshError);
        }

        if (cartState && addedState.sections && Object.keys(addedState.sections).length) {
          cartState.sections = addedState.sections;
          if (window.FoxTheme?.pubsub?.publish && window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
            window.FoxTheme.pubsub.publish(
              window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
              { cart: cartState }
            );
          }
        } else {
          // Protectie cand Shopify nu trimite sectiunile coșului in raspuns.
          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
          );
        }

        document.dispatchEvent(
          new CustomEvent('product-ajax:added', {
            detail: { product: addedState },
          })
        );

        this.cartDrawer = document.querySelector('cart-drawer') || this.cartDrawer;
        if (cartState?.sections && this.cartDrawer?.show) {
          this.cartDrawer.show(this.button);
        }
      } catch (error) {
        console.error(error);
        this.showError(error.message || this.dataset.gnGenericError || 'Something went wrong. Please try again.');
      } finally {
        this.isSubmitting = false;
        this.toggleLoading(false);
      }
    }

    showError(message = '') {
      if (!this.errorMessage) {
        if (message) alert(message);
        return;
      }
      this.errorMessage.hidden = !message;
      this.errorMessage.textContent = message;
    }

    toggleLoading(isLoading) {
      if (!this.button) return;
      this.button.classList.toggle('btn--loading', isLoading);
      this.button.disabled = isLoading;
    }
  }

  customElements.define('lookbook-add-all', LookbookAddAll);
})();
